import api from '../api/template-api';

export default {
    getTemplateById(id) {
        return new Promise((resolve, reject) => {
            api.getTemplateById(id).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getTemplateList(param) {
        let paramObj = {};
        for(let key in param){
            if(param[key] !== null && param[key] !== ''){
                paramObj[key] = param[key];
            }
        }
        return new Promise((resolve, reject) => {
            api.getTemplateList(paramObj).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    },
    saveTemplate(data) {
        return new Promise((resolve, reject) => {
            api.saveTemplate(data).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result);
                } else {
                    reject(data);
                }
            });
        });
    },
    saveTemplatev2 (data) {
        return new Promise((resolve, reject) => {
            api.saveTemplatev2(data).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result);
                } else {
                    reject(data);
                }
            });
        });
    },
    updateTemplate(data, updateCover) {
        return new Promise((resolve, reject) => {
            api.updateTemplate(data, updateCover).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result);
                } else {
                    reject(data);
                }
            });
        });
    },
    hideTemplate(projectId, idArray, showOrHide) {
        return new Promise((resolve, reject) => {
            api.hideTemplate(projectId, idArray, showOrHide).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result);
                } else {
                    reject(data);
                }
            });
        });
    },
    getByGroup(tpGroupId, bgGroupId, projectId) {
        return new Promise((resolve, reject) => {
            api.getByGroup(tpGroupId, bgGroupId, projectId).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getTemplateGroupByProjectId(projectId, type) {
        return new Promise((resolve, reject) => {
            api.getTemplateGroupByProjectId(projectId, type).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    },
    deleteTemplates(idArray) {
        return new Promise((resolve, reject) => {
            api.deleteTemplates(idArray).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || '');
                } else {
                    reject(data);
                }
            });
        });
    },
    deleteTemplateGroup(groupName, type, projectId) {
        return new Promise((resolve, reject) => {
            api.deleteTemplateGroup(groupName, type, projectId).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || '');
                } else {
                    reject(data);
                }
            });
        });
    },
    getNosImgUrlByNetworkImg(imgUrl) {
        return new Promise((resolve, reject) => {
            api.getNosImgUrlByNetworkImg(imgUrl).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getTemplateTags(projectId) {
        return new Promise((resolve, reject) => {
            api.getTemplateTags(projectId).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    },
    getTemplateIndexTags(projectId) {
        return new Promise((resolve, reject) => {
            api.getTemplateIndexTags(projectId).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    },
    getTemplateCategory(projectId) {
        return new Promise((resolve, reject) => {
            api.getTemplateCategory(projectId).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    },
    delTemplateTag(id) {
        return new Promise((resolve, reject) => {
            api.delTemplateTag(id).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getTemplateSize(projectId, param) {
        let paramObj = {};
        for(let key in param){
            if(param[key] !== null && param[key] !== '' && param[key] !== undefined){
                paramObj[key] = param[key];
            }
        }
        return new Promise((resolve, reject) => {
            api.getTemplateSize(projectId, paramObj).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    },
    setTemplateGroupTag(projectId, params) {
        return new Promise((resolve, reject) => {
            api.setTemplateGroupTag(projectId, params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || '');
                } else {
                    reject(data);
                }
            });
        });
    },
    setTplCategory(projectId, params) {
        return new Promise((resolve, reject) => {
            api.setTplCategory(projectId, params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || '');
                } else {
                    reject(data);
                }
            });
        });
    },
    setOneTemplateGroupTag(projectId, params) {
        return new Promise((resolve, reject) => {
            api.setOneTemplateGroupTag(projectId, params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || '');
                } else {
                    reject(data);
                }
            });
        });
    },
    getTemplateGroupByTemplateId(templateId) {
        return new Promise((resolve, reject) => {
            api.getTemplateGroupByTemplateId(templateId).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            }, (error) => {
                reject(error);
            });
        });
    },
    sortTemplates(params) {
        return new Promise((resolve, reject) => {
            api.sortTemplates(params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            }, (error) => {
                reject(error);
            });
        });
    },
    saveTemplateWord(params) {
        return new Promise((resolve, reject) => {
            api.saveTemplateWord(params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            }, (error) => {
                reject(error);
            });
        });
    },
    deleteTemplateWord(ids, projectId) {
        return new Promise((resolve, reject) => {
            api.deleteTemplateWord(ids, projectId).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            }, (error) => {
                reject(error);
            });
        });
    },
    getTemplateWordList(params) {
        return new Promise((resolve, reject) => {
            api.getTemplateWordList(params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            }, (error) => {
                reject(error);
            });
        });
    },
    getTemplateListByProjectId(projectId, name) {
        return new Promise((resolve, reject) => {
            api.getTemplateListByProjectId(projectId, name).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            }, (error) => {
                reject(error);
            });
        });
    },
    copyTemplates(data) {
        return new Promise((resolve, reject) => {
            api.copyTemplates(data).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            }, (error) => {
                reject(error);
            });
        });
    },
    copyTemplateGroup(groupIds, templateIds, type) {
        return new Promise((resolve, reject) => {
            api.copyTemplateGroup(groupIds, templateIds, type).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            }, (error) => {
                reject(error);
            });
        });
    },
    getTemplateView(params) {
        return new Promise((resolve, reject) => {
            api.getTemplateView(params).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    sortTemplateGroup(projectId, tplGroupId, sortNum) {
        return new Promise((resolve, reject) => {
            api.sortTemplateGroup(projectId, tplGroupId, sortNum).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getTemplateCount() {
        return new Promise((resolve, reject) => {
            api.getTemplateCount().then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    getGroupTemplateById(id){
        return new Promise((resolve, reject) => {
            api.getGroupTemplateById(id).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result);
                } else {
                    reject(data);
                }
            });
        });
    },
    copyToTemplateFree(id) {
        return new Promise((resolve, reject) => {
            api.copyToTemplateFree(id).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result);
                } else {
                    reject(data);
                }
            });
        });
    },
    copyToTemplateFreeByProjectId(id) {
        return new Promise((resolve, reject) => {
            api.copyToTemplateFreeByProjectId(id).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result);
                } else {
                    reject(data);
                }
            });
        });
    },
    checkPermissionByTemplateId(id){
        return new Promise((resolve, reject) => {
            api.checkPermissionByTemplateId(id).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result);
                } else {
                    reject(data);
                }
            });
        });
    },
    getDeptWorksCount () {
        return new Promise((resolve, reject) => {
            api.getDeptWorksCount().then(({ data }) => {
                if (data.code === 200) {
                    resolve(data.result)
                } else {
                    reject(data)
                }
            })
        })
    }
}